RxOptions = App.loadClass 'grower::viewmodels/placement/seed_options/RxOptions'
yearUtil = require 'resources/assets/coffee/Core/utils/year'

class exports.RxPlanFactory
    create: (field, spp_handler, callback) =>
        # Assemble all the data we need for the Rx plan
        brands = []
        refuge = null # not sure why this is even here

        if field.hybrid_selection()?
            brands.push { name: 'Brand 1', id: field.hybrid_selection().id }

        if field.low_yield_hybrid_selection()?
            brands.push { name: 'Brand 2', id: field.low_yield_hybrid_selection().id }

        if field.refuge_selection()?
            brands.push { name: 'Refuge', id: field.refuge_selection().id }


        multiHybridAspect = spp_handler.getFieldAspectByName(field.id, 'Multi-Hybrid Rx Plan')

        solver_variables =
            min_pop: parseInt(spp_handler.getFieldAspectByName(field.id, 'Rx Map Min Pop')?.value)
            max_pop: parseInt(spp_handler.getFieldAspectByName(field.id, 'Rx Map Max Pop')?.value)
            max_num_pops: parseInt(spp_handler.getFieldAspectByName(field.id, 'Rx Map Max Num Pops')?.value)
            min_pop_diff: parseInt(spp_handler.getFieldAspectByName(field.id, 'Rx Map Min Pop Diff')?.value)
            max_pop_diff: parseInt(spp_handler.getFieldAspectByName(field.id, 'Rx Map Max Pop Diff')?.value)

        yg = spp_handler.getFieldAspectByName(field.id, 'Yield Goal')

        # Build the structure needed for Rx plan
        options =
            field: field
            year: yearUtil.salesYear() # Todo, use the Year from the survey
            crop: spp_handler.cropID
            crop_name: spp_handler.cropName
            brands: brands
            refuge: refuge
            dual_hybrid: multiHybridAspect?.value ? false
            solver_variables: solver_variables
            yield_goal: yg?.value ? null
            spp: spp_handler
            spp_id: spp_handler.sppID
            from_state: 'grower.placement'

        rx_options = new RxOptions(options)

        # Note this is kinda hax because the SPP doesn't have proper access to angular,
        # or else I could make this be a singleton service that the SPP edits, and is then
        # injected into the RX process.
        window.RxStorage = rx_options # The rx controller will grab this data during it's resolve
        $(window).trigger 'spp.add-planting-rx-plan' # MAJOR HAX! TODO: GET RID OF THIS!

        # Oh what hax is this!?
        spp_handler.dialog.hide()

        $(window).off('rx:completed')
        $(window).on 'rx:completed', (e, data) =>
            callback(data)

        return
